<template>
    <div class="fst-LlmsCheck">
        <el-form ref="form" :model="model" label-position="top" :show-message="false">
            <el-form-item prop="userPrompt" :label="$t('llms.check.userPrompt')" required>
                <el-input v-model="model.userPrompt" type="textarea" :rows="3" @input="saveToSessionStorage()" />
            </el-form-item>
            <el-form-item prop="systemPrompt" :label="$t('llms.check.systemPrompt')">
                <el-input v-model="model.systemPrompt" type="textarea" :rows="3" @input="saveToSessionStorage()" />
            </el-form-item>
            <div v-if="result.text || (result.llm || {}).text" class="result">
                <el-divider>{{ $t('llms.check.result') }}</el-divider>
                <el-form-item v-if="result.text">
                    <el-tabs value="text" type="border-card">
                        <el-tab-pane label="Text" name="text">{{ result.text }}</el-tab-pane>
                        <el-tab-pane v-if="result.json" label="JSON" name="json">
                            <JsonView :value="result.json" :open="3" previewEnabled />
                        </el-tab-pane>
                    </el-tabs>
                </el-form-item>
                <el-form-item v-if="(result.llm || {}).text">
                    <el-tabs value="text" type="border-card">
                        <el-tab-pane label="Text" name="text">{{ result.llm.text }}</el-tab-pane>
                        <el-tab-pane v-if="result.llm.json" label="JSON" name="json">
                            <JsonView :value="result.llm.json" :open="3" previewEnabled />
                        </el-tab-pane>
                    </el-tabs>
                </el-form-item>
            </div>
        </el-form>
    </div>
</template>

<script>
    import _ from 'lodash';
    import { mapActions } from 'vuex';
    import JsonView from '@/commons/components/JsonViewer.vue';

    const DEFAULT_MODEL = {
        script: '',
        systemPrompt: '',
        userPrompt: ''
    };

    export default {
        name: "LlmsCheck",
        components: {JsonView},
        props: {
            value: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                model: {},
                result: {}
            }
        },
        mounted() {
            let sessionStorageValue = _.get(JSON.parse(sessionStorage.getItem('llm')), 'llmCheckForm');
            this.model = _.merge({}, DEFAULT_MODEL, sessionStorageValue, this.value);
        },
        methods: {
            ...mapActions('llm', ['testLlm']),
            apply() {
                return new Promise(resolve => {
                    //console.log('apply', model); return;
                    this.testLlm({request: this.model, prepare: {target: this.$el}}).then(resp => {
                        let data = _.cloneDeep(resp);
                        if (data.llm) {
                            try {
                                data.llm.json = JSON.parse(data.llm.service);
                            } catch (error) {}
                        } else {
                            try {
                                data.json = JSON.parse(data.service);
                            } catch (error) {}
                        }
                        this.result = data;
                        resolve(data);
                    });
                })
            },
            saveToSessionStorage() {
                let sessionStorageLlm = JSON.parse(sessionStorage.getItem('llm')) || {};
                sessionStorageLlm.llmCheckForm = _.pick(this.model, ['systemPrompt','userPrompt']);
                sessionStorage.setItem('llm', JSON.stringify(sessionStorageLlm));
            }
        }
    }
</script>

<style lang="scss">
    .fst-LlmsCheck {
        height: 100%;
        .el-form {
            height: 100%;
            display: flex;
            flex-direction: column;
            .script {
                flex: 1;
                display: flex;
                flex-direction: column;
                overflow: hidden;
                margin-bottom: 0 !important;
                .el-form-item__content {
                    flex: 1;
                    min-height: 200px;
                    display: block;
                }
            }
        }
    }
</style>
